(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('localized-payment-options')) {
    customElements.define('localized-payment-options', class extends HTMLElement {
      connectedCallback() {
        this.updateLabel = () => {
          const link = this.querySelector('.shopify-payment-button__more-options');
          if (link && link.textContent !== this.dataset.label) link.textContent = this.dataset.label;
        };
        this.observer = new MutationObserver(this.updateLabel);
        this.observer.observe(this, { childList: true, subtree: true, characterData: true });
        this.updateLabel();
        this.handleClick = (event) => {
          const link = event.target.closest('.shopify-payment-button__more-options');
          if (!link || !this.contains(link)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const source = this.closest('form');
          const variant = source?.querySelector('[name="id"]');
          if (!source || !variant || variant.disabled || link.getAttribute('aria-disabled') === 'true' || this.busy) return;
          if (!source.reportValidity()) return;
          this.busy = true;
          link.setAttribute('aria-disabled', 'true');
          const target = document.createElement('form');
          target.method = 'post';
          target.action = this.dataset.cartAdd;
          target.hidden = true;
          const fields = new FormData(source);
          fields.set('return_to', '/checkout?locale=' + encodeURIComponent(this.dataset.locale));
          fields.set('locale', this.dataset.locale);
          for (const [name, value] of fields) {
            if (typeof value !== 'string') continue;
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            target.append(input);
          }
          document.body.append(target);
          target.submit();
        };
        this.addEventListener('click', this.handleClick, true);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('click', this.handleClick, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
